/* projects/fitnessforservice/src/app/release-notes/release-notes.component.css */
/*# sourceMappingURL=release-notes.component.css.map */
